import styled from "styled-components";

export const CalendarBaseWrapper = styled.div<{ $theme?: string; $width?: number }>`
  width: 100%;
  .fui-CalendarPicker,
  .fui-CalendarDay {
    width: 100%;
    padding: 8px 0px;
  }
  .fui-Calendar,
  .fui-Calendar__monthPickerWrapper,
  .fui-CalendarDayGrid__table {
    width: 100%;
  }
  .fui-Calendar__goTodayButton {
    margin-top: 0px;
    margin-bottom: 5px;
    margin-right: 12px;
    height: 25px;
    line-height: 25px;
  }
  .fui-CalendarPicker__itemButton {
    min-width: ${(props) => (props.$width ? `${(props.$width - 40) / 4}px` : "40px")};
  }
`;
